// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
/**
 * Lazy loader for the GroundingResourcesDialogContainer with retry capability
 */ export const GroundingResourcesDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-groundingresourcesdialogcontainer" */ "./GroundingResourcesDialogContainer")).then((bundle)=>{
        return {
            default: bundle.GroundingResourcesDialogContainer
        };
    });
export const LazyGroundingResourcesDialogContainer = /*#__PURE__*/ lazy(GroundingResourcesDialogContainerLazyLoader);
